var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"on-search":_vm.getCidades,"id":"comp-search-sel-cid-v-select","options":_vm.options,"placeholder":_vm.placeholder,"filterable":false},on:{"input":_vm.input},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("\n      Digite o nome da cidade\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9346da5c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search-select-cidade.vue
// module id = 793
// module chunks = 245